import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { BrandLogo } from '@/components/BrandLogo';

const roleHome = (role) => (role === 'admin' ? '/admin' : '/app');

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const run = async () => {
      const hash = window.location.hash || '';
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match ? decodeURIComponent(match[1]) : null;
      // clear the fragment
      window.history.replaceState(null, '', window.location.pathname);
      if (!sessionId) { navigate('/'); return; }
      try {
        const res = await api.post('/auth/session', { session_id: sessionId });
        setUser(res.data.user);
        navigate(roleHome(res.data.user.role));
      } catch (e) {
        navigate('/');
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-cream" data-testid="auth-callback">
      <BrandLogo size="md" className="text-ink mb-4 mx-auto block" />
      <div className="w-6 h-6 border-2 border-navy/30 border-t-navy rounded-full animate-spin" />
      <p className="mt-4 text-sm text-navy/60">Giriş yapılıyor...</p>
    </div>
  );
}
